module.exports = __webpack_public_path__ + "img/black-hexagon-mesh.3d03e7ae.jpg";